const ITEMS = [
  "~70% two-choice preference for PALATIVA feed*",
  "≥85% aroma retained after steam conditioning*",
  "+13% calf starter intake, weeks 1–8*",
  "−20% time for fish & shrimp to finish feed*",
  "−50% feed left on shrimp check trays*",
  "+5 pts fat digestibility in young broilers*",
  "Yolk colour fan 11–15 with SENZIA",
];

export const Marquee = () => (
  <section data-testid="stats-marquee" className="relative bg-[var(--forest)] py-6 overflow-hidden">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
          {ITEMS.map((t) => (
            <span key={t} className="flex items-center font-display text-xl md:text-3xl text-white whitespace-nowrap px-8">
              {t}
              <svg width="18" height="18" viewBox="0 0 20 20" className="ml-16"><path d="M2 18C2 8 8 2 18 2c0 10-6 16-16 16Z" fill="#8DC63F" /></svg>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
